import React,{useState, useEffect} from 'react';
import { dancomments } from '@firebase/fire';
import CommentControls from './comment-controls';
import CommentList from './comment-list';
import {Comment} from './types';

function submitComment({username, comment}:Comment){
  const newComment:Comment = {username, comment,date:new Date().getTime()}
  dancomments.push(newComment);
}

const Comments = () => {
  const [comments, setComments] = useState<Comment[] | []>([])
  useEffect(()=>{
    dancomments.on("value", snapshot => {
      const fbVals = snapshot.val() || {}
      const comments:Comment[] = Object.keys(fbVals)
        .map((key):Comment => fbVals[key])
        .sort((x:Comment,y:Comment)=> (y.date as number) - (x.date as number)  )
      setComments(comments)
    });
  },[])

  return <div className="CommentList">
    <h3>Comments</h3>
    <div className="CommentList__Controls"><CommentControls {...{submitComment}}/></div>
    <div className="CommentList__Container"><CommentList {...{comments}}/></div>
  </div>
}
 export default Comments
